import { Injectable } from '@angular/core';
import { AbstractFeatureAclService } from '@y42/feature/acl';
import { Y42FeatureType } from '@y42/json-schema';
import { IntegrationQuery } from '../../state/datasource';

@Injectable({ providedIn: 'root' })
export class IntegrationAclService extends AbstractFeatureAclService<Y42FeatureType.Integration> {
  constructor(query: IntegrationQuery) {
    super({
      featureType: Y42FeatureType.Integration,
      query,
    });
  }
}
